import { map } from '../../../_common/components/uni-component/operation.js';
import { createFromBaseCellRenderer } from '../../common/columns/renderer.js';
import { HeaderAreaTextCell, HeaderAreaTextCellEditing, } from '../../common/header-area/text.js';
export const headerRenderer = {
    view: map(createFromBaseCellRenderer(HeaderAreaTextCell), (props) => ({ ...props, showIcon: true })),
    edit: map(createFromBaseCellRenderer(HeaderAreaTextCellEditing), (props) => ({ ...props, showIcon: true })),
};
//# sourceMappingURL=header-cell.js.map